const initialState = {
  dynamic_components: [],
  products: [],
  server_response: {},
}
export default initialState
